import { List, Map } from 'immutable'
import { handleActions } from 'redux-actions'

import * as actions from 'store/entities/gallery/actions'
import { Gallery } from 'store/records/gallery'
import { GALLERY_SLICED_OFFSET } from 'app/constants/api/galleries'
// @ts-ignore
import { ADMIN_WELCOME_EMAIL } from 'store/entities/adminWelcomeEmail/actionTypes'
import {
  IHandlePending,
  IHandleGalleryImagesSuccess,
  IImage,
  IHandleImageAtGallery,
  IHandleAdminWelcomeEmailSuccess,
  IHandleSetSearchBy,
  IHandleSetImageForReplace,
  IHandleSetIsButtonDisable,
  IHandleUpdateImageUsagePlaces,
} from 'store/entities/gallery/interfaces/reducer.interface'

const handlePending = (state: Map<any, any>, { payload }: IHandlePending) => {
  return state.set('pending', payload.pending)
}

const handleGalleryImages = (state: Map<any, any>) => {
  return state.set('pending', true)
}

const handleGalleryImagesSuccess = (state: Map<any, any>, { payload }: IHandleGalleryImagesSuccess) => {
  const galleryImages = payload.data.reduce((images, item: IImage) => {
    return images.push(
      Map({
        id: item.id,
        url: item.url,
        ext: item.fileType,
        mime: item.fileType === 'png' ? 'image/png' : 'image/jpeg',
        fileName: item.fileName,
        usagePlaces: item.usagePlaces,
      })
    )
  }, List())
  return state.set('images', galleryImages).set('pending', false).set('loaded', true)
}

const handleGalleryImagesFail = (state: Map<any, any>) => {
  return state.set('pending', false)
}

const handleAddImageToGallery = (state: Map<any, any>, { payload }: IHandleImageAtGallery) => {
  const splitLength = payload.url.split(`/`).length
  const imageName = payload.url.split(`/`)[splitLength - 1].split('.')[0]
  if (payload.isConfirmRewriteImage) {
    const oldImage = state.get('images').find((image: Map<string, any>) => image.get('fileName') === imageName)
    const indexForDelete = state
      .get('images')
      .findIndex((image: Map<string, any>) => image.get('fileName') === imageName)
    const newImages = state
      .get('images')
      .delete(indexForDelete)
      .unshift(Map({ url: payload.url, id: Date.now(), fileName: imageName, usagePlaces: oldImage.get('usagePlaces') }))
    return state.set('images', newImages).set('selected', payload.url)
  }
  return state
    .set(
      'images',
      state.get('images').unshift(Map({ url: payload.url, id: Date.now(), fileName: imageName, usagePlaces: '' }))
    )
    .set('selected', payload.url)
}

const handleResetLoaded = (state: Map<any, any>) => {
  return state.set('loaded', false).set('images', List())
}

const handleAdminWelcomeEmailSuccess = (state: Map<any, any>, { payload }: IHandleAdminWelcomeEmailSuccess) => {
  return payload.data ? state.set('selected', payload.data.quoteImage) : state
}

const handleSetImageToDelete = (state: Map<any, any>, { payload }: IHandleImageAtGallery) => {
  return state.set('imageToDelete', payload.url)
}

const handleDeleteImageFromGallery = (state: Map<any, any>) => {
  const indexForDelete = state
    .get('images')
    .findIndex((image: Map<string, any>) => image.get('url') === state.get('imageToDelete'))
  return state.deleteIn(['images', indexForDelete]).set('imageToDelete', null).set('selected', null)
}

const handleSetSearchBy = (state: Map<any, any>, { payload }: IHandleSetSearchBy) => {
  return state.set('search', payload.by)
}

const handleSetImageForReplace = (state: Map<any, any>, { payload }: IHandleSetImageForReplace) => {
  return state.set('imageForReplace', payload.value)
}

const handleSetIsButtonDisable = (state: Map<any, any>, { payload }: IHandleSetIsButtonDisable) => {
  return state.set('isButtonDisable', payload.value)
}

const handleUpdateImageUsagePlaces = (
  state: Map<any, any>,
  { payload: { imagePath, usagePlaces } }: IHandleUpdateImageUsagePlaces
) => {
  const indexForUpdate = state.get('images').findIndex((image: Map<string, any>) => image.get('url') === imagePath)
  const existImage = state.get('images').find((image: Map<string, any>) => image.get('url') === imagePath)
  const existUsagePlaces = existImage.get('usagePlaces')
  return state.setIn(['images', indexForUpdate, 'usagePlaces'], existUsagePlaces + usagePlaces)
}

const handleIncreaseLazyLoaded = (state: Map<any, any>) => {
  return state.set('lazyLoaded', state.get('lazyLoaded') + GALLERY_SLICED_OFFSET)
}

export default handleActions(
  {
    [actions.setPending as any]: handlePending,
    [actions.addImageToGallery as any]: handleAddImageToGallery,
    [actions.resetLoaded as any]: handleResetLoaded,
    [actions.fetchGalleryImages as any]: handleGalleryImages,
    [actions.fetchGalleryImages.success as any]: handleGalleryImagesSuccess,
    [actions.fetchGalleryImages.fail as any]: handleGalleryImagesFail,
    [actions.setSearchBy as any]: handleSetSearchBy,
    [ADMIN_WELCOME_EMAIL.GET.SUCCESS]: handleAdminWelcomeEmailSuccess,
    [actions.deleteImageFromGallery.success as any]: handleDeleteImageFromGallery,
    [actions.setImageToDelete as any]: handleSetImageToDelete,
    [actions.setImageForReplace as any]: handleSetImageForReplace,
    [actions.setIsButtonDisable as any]: handleSetIsButtonDisable,
    [actions.updateImageUsagePlaces as any]: handleUpdateImageUsagePlaces,
    [actions.increaseLazyLoaded as any]: handleIncreaseLazyLoaded,
  } as any,
  new Gallery()
)
